// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3opnc","left":"InfoRow_left__39k6y"};